import { hexToHsva, rgbStringToHsva, validHex } from '@uiw/color-convert'
import { HSVA } from '../store/useColorStore'

/**
 * Reads a branding colour saved by the backend.
 *
 * The stored value is a free-form string, so what comes back is whichever
 * notation wrote it: this form saves `rgb(r, g, b)`, while a venue seeded
 * through the API examples carries hex. The notation has to be decided here
 * because `rgbStringToHsva` does not fail on a hex string — it quietly returns
 * black, which then reads as a deliberate colour choice.
 *
 * Alpha is pinned to 1: the pickers in this form do not offer transparency, so
 * a colour restored with a lower alpha could never be raised again.
 */
export const colorStringToHsva = (value: string): HSVA => ({
  ...(validHex(value) ? hexToHsva(value) : rgbStringToHsva(value)),
  a: 1
})
